import React, { useState } from 'react';
import { IconButton } from '@mui/material';
import HistoryIcon from '@mui/icons-material/History';
import RecentClientsMenu from '../RecentClientsMenu';

export const RecentClientsButton = () => {
	const [anchorEl, setAnchorEl] = useState(null);

	const handleOpen = (event) => setAnchorEl(event.currentTarget);
	const handleClose = () => setAnchorEl(null);

	return (
		<>
			<IconButton
				size='small'
				onClick={handleOpen}
				aria-controls='recent-clients-menu-appbar'
				aria-haspopup='true'
			>
				<HistoryIcon color='primary' />
			</IconButton>
			<RecentClientsMenu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose} />
		</>
	);
};
